import { writable } from "svelte/store";
const urlSearchParams = new URLSearchParams(window.location.search);
const initComprehensive = !!(urlSearchParams.has("comprehensive") ? urlSearchParams.get("comprehensive") : "false").replace("false", "");
const initId = urlSearchParams.has("id") ? urlSearchParams.get("id") : "";
const initModal = initId.length === 1;
const initX = urlSearchParams.has("x") ? urlSearchParams.get("x") : "";
const initY = urlSearchParams.has("y") ? urlSearchParams.get("y") : "";
export const comprehensive = writable(initComprehensive);
export const coordinate = writable([initX, initY]);
export const hover = writable("");
export const identifier = writable(initId);
export const modal = writable(initId);
export const positions = writable([]);
